'use strict';

var cov_kpocyeexw = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/municipalities.js',
        hash = '28fc60a43d2ab7a28ef66c83dfec96da9b2bc61e',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/municipalities.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 18
                },
                end: {
                    line: 12,
                    column: 77
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 59
                },
                end: {
                    line: 12,
                    column: 76
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 13,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'municipalities',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 40
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 51
                    },
                    end: {
                        line: 12,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 59
                    },
                    end: {
                        line: 12,
                        column: 76
                    }
                },
                line: 12
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_kpocyeexw.s[0]++;
(function () {
    'use strict';

    cov_kpocyeexw.f[0]++;
    cov_kpocyeexw.s[1]++;
    angular.module('app').filter('municipalities', municipalities);

    /* @ngInject */
    function municipalities($rootScope) {
        cov_kpocyeexw.f[1]++;
        cov_kpocyeexw.s[2]++;

        return function (input) {
            cov_kpocyeexw.f[2]++;
            cov_kpocyeexw.s[3]++;

            if (input) {
                cov_kpocyeexw.b[0][0]++;

                var matches = (cov_kpocyeexw.s[4]++, $rootScope.municipalities.filter(function (item) {
                    cov_kpocyeexw.f[3]++;
                    cov_kpocyeexw.s[5]++;
                    return item.id === input;
                }));
                cov_kpocyeexw.s[6]++;
                return matches[0].name;
            } else {
                cov_kpocyeexw.b[0][1]++;
            }
        };
    }
})();